import { apiClient } from './api.client';
import type { components } from '../types/api.generated';
import { handleApiResponse, handleApiArrayResponse } from './apiHelpers';

export type Distribution = components['schemas']['Distribution'];
export type CreateDistributionRequest = components['schemas']['CreateDistributionRequest'];

export const distributionService = {
  /**
   * Get all distributions
   */
  async list() {
    const response = await apiClient.GET('/distributions');
    return handleApiArrayResponse<Distribution>(response as any);
  },

  /**
   * Get distribution by ID
   */
  async get(id: string) {
    const response = await apiClient.GET('/distributions/{id}', {
      params: { path: { id } }
    });
    return handleApiResponse<Distribution>(response as any);
  },

  /**
   * Create new distribution (board only)
   */
  async create(distribution: CreateDistributionRequest) {
    const response = await apiClient.POST('/distributions', {
      body: distribution
    });
    return handleApiResponse<Distribution>(response as any);
  },

  /**
   * Approve distribution (board only)
   */
  async approve(id: string) {
    const response = await apiClient.POST('/distributions/{id}/approve', {
      params: { path: { id } }
    });
    return handleApiResponse<Distribution>(response as any);
  },

  /**
   * Execute distribution (treasurer only)
   */
  async execute(id: string) {
    const response = await apiClient.POST('/distributions/{id}/execute', {
      params: { path: { id } }
    });
    return handleApiResponse<Distribution>(response as any);
  }
};
